export default function () {
  const widgetName = 'mainmultischedulefeature';
  const widgetOpts = mainmultischedulefeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    // options
    allEventsLink: true,
    allEventsLinkText: 'see all events',
    hasImages: true,
    imageBackground: false,
    lazyLoadImages: true,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    maxItemsVisible: 4,
    isResponsive: false,
    hasDescription: false,
    textContainer: true,
    link: 'buttons', //options are 'all', 'text', 'image', 'imageAndText', or ''
    attributeOrder: {
      1: 'image',
      2: 'date',
      3: 'title',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function () {
      $(`#${widgetName} .featureItem .void-link`).removeAttr('href');
      $(`#${widgetName}`).prepend('<span class="msf-title">Upcoming <span>Events</span></span>');
      $(`#${widgetName} .all-events-btn`).appendTo(`#${widgetName}`);
      $(`#${widgetName} .featureItem`).each(function () {
        const titleElement = $(this).find('.featureItemTitle');
        let titleText = titleElement.text();
        if (titleText.length > 35) {
          titleText = titleText.substring(0, 35) + '...';
        }
        let buttonWrap = $(this).find('.button');
        if (buttonWrap.is('[href=""]')) {
          $(this).addClass('void-link');
        }
        titleElement.text(titleText);
        const eventDate = $(this).find($('span.featureItemDate'));
        const datesMonth = eventDate.text().slice(0, 3);
        const datesDay = eventDate.text().slice(4, 7).replace(',', '');
        eventDate.text(datesMonth);
        eventDate.append(`<span>${datesDay}</span>`);
        const img = $(this).find('.featureItemImage img');
        const imgDataSrc = img.attr('data-src');
        if (imgDataSrc.includes('no_image_available.jpg')) {
          img.attr('src', `${FULLCLIENTTHEMEPATH}images/no_image_available.jpg`);
        }
      });
    },
  });
}
